<template>
  <div class="c-multiple-img" :style="{ textAlign: textAlign }">
    <div class="multiple-img" v-for="(img, idx) of imgs" :key="idx">
      <single-img v-bind="img" />
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import SingleImg from '@/components/Global/SingleImg.vue';

export default defineComponent({
  name: 'MultipleImg',
  components: {
    SingleImg,
  },
  props: {
    imgs: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
<style lang="scss" scoped>
.c-multiple-img {
  // @include flex();
  width: 100%;
  overflow: scroll;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
    height: 0;
  }
}

.multiple-img {
  display: inline-block;
  width: 150px;

  & + & {
    margin-left: 10px;
  }
}
</style>
